import { StripeTerminalError } from './StripeTerminalError';

export class StripeTerminalConnectionTokenError extends StripeTerminalError {
  constructor(message: unknown) {
    super(message);
    this.name = 'StripeTerminalConnectionTokenError';
  }
}
